import MinnesotaHeroSection from "./components/HeroSection";
import MinnesotaCitiesDirectory from "./components/CitiesDirectory";
import MinnesotaStateResources from "./components/StateResources";
import MinnesotaFAQSection, { faqs } from "./components/FAQSection";
import MinnesotaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const minnesotaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MinnesotaPage() {
  return (
    <>
      <CitySEOHead
        city="Minnesota"
        state="Minnesota"
        stateAbbr="MN"
        route="/states/minnesota"
        title="Minnesota Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Minnesota — Minneapolis, St. Paul, Rochester, Duluth, Bloomington. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Minnesota, United States"
        geoPosition="46.7296;-94.6859"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={minnesotaServices}
      />
      <div className="font-sans">
        <MinnesotaHeroSection />
        <MinnesotaCitiesDirectory />
        <MinnesotaStateResources />
        <MinnesotaFAQSection />
        <SEOCrossLinks state="MN" />
        <MinnesotaFinalCTA />
      </div>
    </>
  );
}